<template>
  <div class="order-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
          v-model="searchParams.prodNameLike"
          :placeholder="$t('order.productNamePlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          v-model="searchParams.personNameLike"
          :placeholder="$t('order.userNamePlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="margin-top"
    >
      <el-table-column prop="cartId" :label="$t('storeOrderCartManage.orderNumber')" align="center"></el-table-column>
      <el-table-column prop="appName" :label="$t('storeOrderCartManage.platform')" align="center"></el-table-column>
      <el-table-column prop="shopName" :label="$t('storeOrderCartManage.shop')" align="center"></el-table-column>
      <el-table-column prop="cartType" :label="$t('storeOrderCartManage.type')" align="center">
        <template #default="scope">
          {{ scope.row.cartType === '3307' ? $t('storeOrderCartManage.service') : $t('order.product') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('storeOrderCartManage.name')" align="center">
        <template #default="scope">
          <span v-if="scope.row.cartType === '3307'">{{ scope.row.prodName }}</span>
          <span v-else>{{ scope.row.prodName }}({{ scope.row.specValue }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="cartNum" :label="$t('storeOrderCartManage.quantity')" align="center"></el-table-column>
      <el-table-column prop="personName" :label="$t('storeOrderCartManage.userName')" align="center"></el-table-column>
      <el-table-column prop="payPrice" :label="$t('storeOrderCartManage.paymentAmount')" align="center"></el-table-column>
      <el-table-column prop="stateName" :label="$t('storeOrderCartManage.orderStatus')" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('storeOrderCartManage.createTime')" align="center"></el-table-column>
    </el-table>

    <el-pagination
      class="margin-top"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import { queryAdminStoreOrderCart } from '@/api/admin/storeOrderCartManage/storeOrderCartManageApi'

export default {
  name: 'AShopDetailOrder',

  data() {
    return {
      searchParams: {
        prodNameLike: '',
        personNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          personNameLike: this.searchParams.personNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        
        const res = await queryAdminStoreOrderCart(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取订单列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.order-container {
}
.search-row {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
</style>